import { HStack, IconButton, Select, Text } from '@chakra-ui/react'
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker'

import { Icon } from '../../Icons/Icon'
import { generateYears } from './DateInput.utils'

const today = new Date()
const years = generateYears(
  today.getFullYear() - 100,
  today.getFullYear() + 100,
)

export const CustomCalendarHeader = ({
  date,
  changeYear,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}: ReactDatePickerCustomHeaderProps) => (
  <HStack justify="space-between" pt="6px">
    <IconButton
      onClick={decreaseMonth}
      disabled={prevMonthButtonDisabled}
      p="5px"
      icon={
        <Icon
          icon="TriangleArrowIcon"
          boxSize="18px"
          transform="rotate(180deg)"
        />
      }
      aria-label="Decrease Month"
    />

    <HStack gap="4px">
      <Text fontSize="12px" fontWeight="600">
        {date.toLocaleString('default', { month: 'long' })},
      </Text>
      <Select
        variant="unstyled"
        // fontSize="12px"
        fontWeight="600"
        value={date.getFullYear()}
        iconSize="14px"
        icon={<Icon icon="ChevronIcon" />}
        size="md" // TODO: resolve padding issue.
        mr="-12px" // TODO: resolve padding issue.
        onChange={({ target: { value } }) => changeYear(Number(value))}
      >
        {years.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </Select>
    </HStack>
    <IconButton
      onClick={increaseMonth}
      disabled={nextMonthButtonDisabled}
      p="5px"
      icon={<Icon icon="TriangleArrowIcon" boxSize="18px" />}
      aria-label="Decrease Month"
    />
  </HStack>
)

export const CustomCalendarDayContents = (dayOfMonth: number) => (
  <Text fontSize="12px" fontWeight="500">
    {dayOfMonth}
  </Text>
)
